import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const reminders = async (data: RemindersReqT) => {
  const { pageParam, title, type, date, customerId, archive, quickFilters } =
    data;

  const qs = `?archived=${archive ? 1 : 0}&page=${pageParam ?? 1}&title=${
    title ?? ""
  }&type=${type ?? ""}&remind_at=${date ?? ""}&customer_id=${customerId ?? ""}${
    quickFilters ? "&" + quickFilters : ""
  }`;

  return axios.get(Routes.REMINDERS + qs);
};

export const useReminders = (params: RemindersReqT) => {
  const { title, date, type, archive, customerId, quickFilters } = params;
  return useInfiniteQuery({
    queryKey: [
      Keys.REMINDERS_QRY,
      title,
      type,
      date,
      customerId,
      archive,
      quickFilters,
    ],
    queryFn: ({ pageParam = 1 }) => reminders({ pageParam, ...params }),
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    getPreviousPageParam: (firstPage) => firstPage.data.links.prev,
    cacheTime: 0,
  });
};
